import { render, staticRenderFns } from "./GYFY.vue?vue&type=template&id=0e3fc62a&scoped=true&"
import script from "./GYFY.vue?vue&type=script&lang=js&"
export * from "./GYFY.vue?vue&type=script&lang=js&"
import style0 from "./GYFY.vue?vue&type=style&index=0&id=0e3fc62a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3fc62a",
  null
  
)

export default component.exports